import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BarRatingModule } from 'ngx-bar-rating';
import { ConversationService } from './assessor/conversation.service';
import { ChatAssessorService } from './chat-assessor.service';
import { BrowserUtilsService } from './../../services/browser-utils.service';
import { ChatAssessorComponent } from './assessor/chat-assessor.component';
import { UserMessageInputComponent } from './assessor/user-message-input.component';
import { ConversationAssessorComponent } from './conversation/conversation-assessor.component';
import { ConversationAssessorDirective } from './conversation/conversation-assessor.directive';
import { UserMessageRender } from './conversation/user-message-render/user-message-render.component';
import { AssessorMessageRender } from './conversation/assessor-message-render/assessor-message-render.component';
import { MarkdownToHtmlPipeModule } from '../../pipes/markdown/markdown.module';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        BarRatingModule,
        FormsModule,
        ReactiveFormsModule,
        MarkdownToHtmlPipeModule,
    ],
    declarations: [
        ChatAssessorComponent,
        UserMessageInputComponent,
        ConversationAssessorComponent,
        ConversationAssessorDirective,
        UserMessageRender,
        AssessorMessageRender,
    ],
    exports: [
        ChatAssessorComponent,
    ],
    providers: [
        ConversationService,
        ChatAssessorService,
        BrowserUtilsService,
    ],
})

export class ChatAssessorModule {}
